import axios from 'axios';
import { promiseJwt } from '@isyc-react/oc-api/auth/auth-jwt.utils';
export const customAutoLogin = (form) => promiseJwt(() => axios.post(`/api/public/bailleurs/login`, {
    data: form.data,
    sign: form.sign
}));
